import './DistributionEditModal.scss';

import { func, object } from 'prop-types';
import React from 'react';

import {AAMBeaconButton} from "components/shared/Beacon";
import {resetAccountEligibleForExchange} from "../../../../services/Rest";

const DistributionEditModal = ({
    handleOnClick
}) => {
    const handleClick = () => {
      Promise.all([
        resetAccountEligibleForExchange()
      ]).then(() => {
        handleOnClick();
      });
    }

    return (
      <div>
          <div className="edit-button-v2">
              <AAMBeaconButton
                  variant="tertiary"
                  onBeaconEventClick={()=>{handleClick()}}
                  scale={'jumbo'}>
                  Edit
              </AAMBeaconButton>
          </div>
      </div>
    );
};

DistributionEditModal.propTypes = {
    distributionToEdit: object.isRequired,
    onClose: func.isRequired,
    onSave: func.isRequired
};

export default DistributionEditModal;